import styled from 'styled-components';
import { BP_MOBILE_MAX } from '../../assets/styles/breakpoints';

export const GuaranteeFundBannerSC = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 50px;

  .left-wrapper,
  .right-wrapper {
    width: 100%;
  }

  .left-wrapper {
    padding-right: 24px;
    max-width: 400px;
    text-align: center;

    .title {
      margin-bottom: 32px;
    }
    .description {
      margin-bottom: 32px;
    }
    .note {
      margin-top: 16px;
    }
  }

  .right-wrapper {
    padding-left: 24px;
    max-width: 500px;
  }

  @media only screen and (max-width: ${BP_MOBILE_MAX}px) {
    flex-direction: column;

    .left-wrapper,
    .right-wrapper {
      max-width: none;
      width: 100%;
      padding: 0;
    }
  }
`;
